export default "__VITE_ASSET__9be6e0fa__"